module.exports = __webpack_public_path__ + "img/icon4-1(3).07a43dc1.png";